// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2l4ap","addWidgetButton":"Header_addWidgetButton__2YdYX","dashboardTabs":"Header_dashboardTabs__35One","active":"Header_active__IT0wP"};